import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddDesignation = createAsyncThunk(
  "other/AddDesignation",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/designation-create/`, data)
    return response.data
  }
); 

export const UpdateDesignation = createAsyncThunk(
  "other/UpdateDesignation",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/designation-update/${data.id}/`, data)
    return response.data
  }
);

export const GetDesignationList = createAsyncThunk(
  "user/GetDesignationList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/designation-list/`)
    return data
  }
);

export const DeleteDesignation = createAsyncThunk(
  "other/DeleteDesignation",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/designation-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

